module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Placement des lieux sur la carte","description":"Utilisez cette carte pour vérifier le placement des lieux"},"en":{"title":"Location Placement on Map","description":"Use this map to verify the location placement"}}')
  delete Component.options._Ctor
}
